import { motion } from "framer-motion";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function PageHero({ overline, title, subtitle, image, imageAlt, breadcrumbs, children, compact }) {
  return (
    <section className="relative grain overflow-hidden border-b border-white/10 bg-[#070707]">
      <div className="absolute inset-0">
        {image ? (
          <>
            <img src={image} alt={imageAlt || (typeof title === "string" ? title : "")} className="h-full w-full object-cover opacity-25 grayscale-[0.3]" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#070707] via-[#070707]/85 to-[#070707]/40" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#070707] to-transparent" />
          </>
        ) : (
          <div className="absolute inset-0 obsidian" />
        )}
        <div className="pointer-events-none absolute -left-40 top-0 h-96 w-96 rounded-full bg-gold/10 blur-[140px]" />
      </div>
      <div className="absolute inset-x-0 top-0 z-10 h-px gold-divider opacity-50" />
      <div className={`container-x relative z-10 ${compact ? "pt-32 pb-12" : "pt-36 pb-16 sm:pb-20"}`}>
        {breadcrumbs && <div className="mb-7"><Breadcrumbs items={breadcrumbs} /></div>}
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          {overline && (
            <span className="kicker inline-flex items-center gap-3 text-[11px] text-gold">
              <span className="h-px w-8 bg-gold/70" /> {overline}
            </span>
          )}
          <h1 className="mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[3.3rem]">{title}</h1>
          {subtitle && <p className="mt-5 max-w-2xl text-base font-light leading-relaxed text-neutral-300 sm:text-lg">{subtitle}</p>}
          {children}
        </motion.div>
      </div>
    </section>
  );
}
